import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import {
    ANALYTICS,
    AUTH_CALL_BACK,
    CREATE_SERIES,
    FORGOT_PASSWORD,
    HOME,
    LINK_SOCIAL_ACCOUNTS,
    RESET_PASSWORD,
    SERIES,
    SIGN_IN,
    SIGN_UP,
    UPGRADE_PLAN,
    VERIFY_ACCOUNT,
} from './route';
import ForgotPassword from './pages/auth/ForgotPassword';
import SignIn from './pages/auth/SignIn';
import Home from './pages/Dashboard';
import Analytics from './pages/Analytics';
import SignUp from './pages/auth/SignUp';
import MySeries from './pages/series/MySeries';
import CreateSeries from './pages/series/CreateSeries';
import UpgradePlan from './pages/UpgradePlan';
import Verification from './pages/auth/Verification';
import React from 'react';
// Helper function to check if user is authenticated
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthCallbackHandler from './AuthCallback';
import ResetPassword from './pages/auth/ResetPassword';
import LinkAccounts from './pages/LinkAccounts';
import ForIgVideos from './components/ForIgVideos';
import FastShortsVideos from "./components/FastShortVideos";
const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
};

// Wrapper for routes that should only be accessible when not authenticated
const UnauthenticatedRoute = ({ children }) => {
  return !isAuthenticated() ? children : <Navigate to={HOME} />;
};

// Wrapper for routes that require authentication
const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to={SIGN_IN} />;
};
function App() {
  return (
    <Router>
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='colored'
      />
      <div className='min-h-screen bg-gray-50'>
        <Routes>
          {/*<Route*/}
          {/*  path={AUTH_CALL_BACK}*/}
          {/*  element={*/}
          {/*    <UnauthenticatedRoute>*/}
          {/*      <AuthCallbackHandler />*/}
          {/*    </UnauthenticatedRoute>*/}
          {/*  }*/}
          {/*/>*/}
            <Route
                path={AUTH_CALL_BACK}
                element={<AuthCallbackHandler />}
            />
          <Route
            path={HOME}
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path={ANALYTICS}
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route
            path={SERIES}
            element={
              <ProtectedRoute>
                <MySeries />
              </ProtectedRoute>
            }
          />
            <Route
                path={`${CREATE_SERIES}/:seriesId`}
                element={
                    <ProtectedRoute>
                        <CreateSeries />
                    </ProtectedRoute>
                }
            />
          <Route
            path={CREATE_SERIES}
            element={
              <ProtectedRoute>
                <CreateSeries />
              </ProtectedRoute>
            }
          />

          <Route
            path={UPGRADE_PLAN}
            element={
              <ProtectedRoute>
                <UpgradePlan />
              </ProtectedRoute>
            }
          />
          <Route
            path={LINK_SOCIAL_ACCOUNTS}
            element={
              <ProtectedRoute>
                <LinkAccounts />
              </ProtectedRoute>
            }
          />
         <Route
            path="ig-videos"
            element={
              <ProtectedRoute>
                <ForIgVideos />
              </ProtectedRoute>
            }
          />
            <Route
                path="fast-lol"
                element={
                    <ProtectedRoute>
                        <FastShortsVideos />
                    </ProtectedRoute>
                }
            />
          <Route
            path={FORGOT_PASSWORD}
            element={
              <UnauthenticatedRoute>
                <ForgotPassword />
              </UnauthenticatedRoute>
            }
          />
          <Route
            path={RESET_PASSWORD}
            element={
              <UnauthenticatedRoute>
                <ResetPassword />
              </UnauthenticatedRoute>
            }
          />
          <Route
            path={SIGN_IN}
            element={
              <UnauthenticatedRoute>
                <SignIn />
              </UnauthenticatedRoute>
            }
          />
          <Route
            path={SIGN_UP}
            element={
              <UnauthenticatedRoute>
                <SignUp />
              </UnauthenticatedRoute>
            }
          />
          <Route
            path={VERIFY_ACCOUNT}
            element={
              <UnauthenticatedRoute>
                <Verification />
              </UnauthenticatedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
